// Page 2 Mockup — Planning chauffeurs Gantt style Progression Live
import React, { useState } from 'react';
import { Calendar, Clock, ChevronLeft, ChevronRight, ArrowLeft, Filter, FileSpreadsheet } from 'lucide-react';

export const DriverPlanningMockup = ({ onSwitchPage }) => {
  const [viewMode, setViewMode] = useState('1_jour');
  // Timeline complète 24h — utilisateur peut scroller horizontalement pour voir
  // les transports qui s'étendent sur deux jours (nuit + jour suivant)
  const timeSlots = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, '0')}:00`);

  const drivers = [
    { id: 'drv-1', name: 'Marc Tremblay', truck: 'Camion #102 (53ft)', stopsCount: 3, avatar: 'MT', hasAlert: true,
      assignments: [
        { id: 'asg-1', code: 'CMD-1083', client: 'Cascades Emballage', startCol: 8, span: 2.5, time: '08:00 - 10:30', type: 'LIVR.', city: 'Dorval', bg: 'bg-red-500/25 border-red-500/80 text-red-200' },
        { id: 'asg-2', code: 'CMD-1089', client: 'Boulangerie St-Méthode', startCol: 11, span: 3, time: '11:00 - 14:00', type: 'CUEILL.', city: 'Magog', bg: 'bg-blue-500/25 border-blue-500/80 text-blue-200' },
      ] },
    { id: 'drv-2', name: 'Jean-Luc Roy', truck: 'Camion #104 (Drybox)', stopsCount: 4, avatar: 'JR',
      assignments: [
        { id: 'asg-3', code: 'CMD-1084', client: "Sobey's Distribution", startCol: 9, span: 4, time: '09:00 - 13:00', type: 'LIVR.', city: 'Québec', bg: 'bg-cyan-500/25 border-cyan-500/80 text-cyan-200' },
        { id: 'asg-4', code: 'CMD-1091', client: 'Groupe Canam', startCol: 14, span: 3, time: '14:00 - 17:00', type: 'CUEILL.', city: 'St-Gédéon', bg: 'bg-blue-500/25 border-blue-500/80 text-blue-200' },
      ] },
    { id: 'drv-3', name: 'Alexandre Gagnon', truck: 'Camion #108 (Reefer)', stopsCount: 2, avatar: 'AG',
      assignments: [{ id: 'asg-5', code: 'CMD-1086', client: 'Agropur Coopérative', startCol: 8, span: 2.2, time: '08:00 - 10:15', type: 'LIVR.', city: 'Longueuil', bg: 'bg-emerald-500/25 border-emerald-500/80 text-emerald-200' }] },
    { id: 'drv-4', name: 'David Bouchard', truck: 'Camion #110 (Flatbed)', stopsCount: 3, avatar: 'DB',
      assignments: [
        { id: 'asg-6', code: 'CMD-1085', client: 'Canac Marquis', startCol: 10, span: 4.5, time: '10:00 - 14:30', type: 'LIVR.', city: 'Lévis', bg: 'bg-cyan-500/25 border-cyan-500/80 text-cyan-200' },
        // Exemple d'un transport de nuit qui s'étend sur 2 jours (démarre 22h30, finit 04h30 le lendemain)
        { id: 'asg-6b', code: 'CMD-1099', client: 'Transport nuit — Ottawa', startCol: 22.5, span: 1.5, time: '22:30 - 00:00', type: 'CUEILL.', city: 'Ottawa (jour+1)', bg: 'bg-purple-500/25 border-purple-500/80 text-purple-200' },
      ] },
    { id: 'drv-5', name: 'Stéphane Côté', truck: 'Camion #114 (53ft)', stopsCount: 0, avatar: 'SC', assignments: [] },
    { id: 'drv-6', name: 'Patrice Morin', truck: 'Camion #116', stopsCount: 0, avatar: 'PM', assignments: [] },
    { id: 'drv-7', name: 'Richard Bernatchez', truck: 'Camion #118', stopsCount: 6, avatar: 'RB',
      assignments: [
        { id: 'asg-7', code: 'CMD-1093', client: 'Metro', startCol: 8, span: 1.5, time: '08:00 - 09:30', type: 'LIVR.', city: 'Laval', bg: 'bg-emerald-500/25 border-emerald-500/80 text-emerald-200' },
        { id: 'asg-8', code: 'CMD-1094', client: 'IGA', startCol: 10, span: 2, time: '10:00 - 12:00', type: 'LIVR.', city: 'Terrebonne', bg: 'bg-cyan-500/25 border-cyan-500/80 text-cyan-200' },
      ] },
    { id: 'drv-8', name: 'Carlo Chevarie', truck: 'Camion #120', stopsCount: 0, avatar: 'CC', assignments: [] },
  ];

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col font-sans" data-testid="driver-planning-mockup">
      <div className="bg-slate-900 border-b border-slate-800 px-4 py-3 flex flex-wrap items-center justify-between gap-3 sticky top-0 z-30">
        <div className="flex items-center gap-3">
          <button onClick={onSwitchPage} className="p-1.5 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-lg flex items-center gap-1 text-xs font-semibold">
            <ArrowLeft size={14} /><span>Commandes</span>
          </button>
          <div className="h-5 w-px bg-slate-800" />
          <div>
            <h1 className="text-lg font-bold uppercase tracking-wide text-white leading-tight flex items-center gap-2"><Clock className="text-amber-500" size={18} /> Planning des Chauffeurs</h1>
            <p className="text-xs text-slate-400">Vue Timeline Gantt (Progression Live)</p>
          </div>
          <div className="flex items-center bg-slate-950 border border-slate-800 p-1 rounded-lg ml-2">
            <button onClick={onSwitchPage} className="flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-medium text-slate-400 hover:text-white hover:bg-slate-800"><FileSpreadsheet size={14} /> Grille Commandes</button>
            <button className="flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-semibold bg-amber-500 text-black shadow-sm"><Clock size={14} /> Planning</button>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center bg-slate-950 border border-slate-800 p-1 rounded-lg text-xs font-semibold">
            {[{ id: '1_jour', label: '1 Jour' }, { id: '1_semaine', label: '1 Semaine' }, { id: '1_mois', label: '1 Mois' }].map(({ id, label }) => (
              <button key={id} onClick={() => setViewMode(id)} className={`px-3 py-1 rounded-md ${viewMode === id ? 'bg-amber-500 text-black shadow-sm' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}>{label}</button>
            ))}
          </div>
          <div className="flex items-center bg-slate-800 border border-slate-700 rounded-lg p-0.5 text-xs">
            <button className="p-1.5 hover:bg-slate-700 rounded text-slate-300"><ChevronLeft size={16} /></button>
            <span className="px-3 font-semibold text-slate-200 flex items-center gap-1.5"><Calendar size={13} className="text-amber-500" /> Mercredi 15 Juillet 2026</span>
            <button className="p-1.5 hover:bg-slate-700 rounded text-slate-300"><ChevronRight size={16} /></button>
          </div>
        </div>
      </div>

      <div className="flex-1 flex overflow-hidden">
        <div className="flex-1 overflow-auto bg-slate-950 flex flex-col">
          <div className="flex border-b border-slate-800 bg-slate-900 sticky top-0 z-20 shrink-0 text-xs font-mono">
            <div className="w-64 shrink-0 p-2.5 font-sans font-bold text-slate-400 uppercase tracking-wider text-[11px] border-r border-slate-800 flex items-center justify-between sticky left-0 z-30 bg-slate-900"><span>Chauffeur &amp; Camion ({drivers.length})</span><Filter size={13} className="text-slate-500 hover:text-amber-400 cursor-pointer" /></div>
            <div className="flex-1 flex min-w-[1920px]">
              {timeSlots.map((time) => (<div key={time} className="flex-1 text-center py-2 border-r border-slate-800/80 text-slate-400 font-semibold text-[11px]">{time}</div>))}
            </div>
          </div>

          <div className="divide-y divide-slate-800/80 text-xs">
            {drivers.map((driver) => (
              <div key={driver.id} className="flex min-h-[60px] hover:bg-slate-900/40 group">
                <div className="w-64 shrink-0 p-3 bg-slate-900/70 border-r border-slate-800 flex items-center justify-between sticky left-0 z-10">
                  <div className="flex items-center gap-2.5 min-w-0">
                    <div className="w-9 h-9 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center font-bold text-amber-500 shrink-0 text-xs">{driver.avatar}</div>
                    <div className="min-w-0">
                      <div className="font-bold text-white text-xs truncate flex items-center gap-1.5">
                        <span>{driver.name}</span>
                        {driver.hasAlert && <span className="w-2 h-2 rounded-full bg-red-500 animate-ping" title="Alerte retard" />}
                      </div>
                      <p className="text-[11px] text-slate-400 truncate">{driver.truck}</p>
                    </div>
                  </div>
                  <span className="bg-slate-800 text-slate-300 font-mono text-[10px] px-2 py-0.5 rounded-full border border-slate-700 shrink-0">{driver.stopsCount} arrêts</span>
                </div>
                <div className="flex-1 relative min-w-[1920px] bg-slate-950 flex">
                  {timeSlots.map((time) => (<div key={time} className="flex-1 border-r border-slate-900/80 h-full pointer-events-none" />))}
                  <div className="absolute top-0 bottom-0 z-10 w-0.5 bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)] pointer-events-none" style={{ left: `${(13.75 / 24) * 100}%` }} title="Heure actuelle : 13:45">
                    <div className="w-2 h-2 rounded-full bg-red-500 -ml-[3px] -top-1 absolute" />
                  </div>
                  {driver.assignments.map((asg) => {
                    const leftPct = (asg.startCol / timeSlots.length) * 100;
                    const widthPct = (asg.span / timeSlots.length) * 100;
                    return (
                      <div
                        key={asg.id}
                        className={`absolute top-1.5 bottom-1.5 rounded-lg border-2 px-2 py-1 shadow-md flex flex-col justify-between overflow-hidden cursor-pointer hover:brightness-110 hover:z-20 ${asg.bg}`}
                        style={{ left: `${leftPct}%`, width: `${widthPct}%` }}
                      >
                        {/* Ligne 1 : [Code] [Client centré] [Tag] */}
                        <div className="flex items-center justify-between gap-1.5 leading-tight">
                          <span className="font-bold font-mono text-[10px] shrink-0">{asg.code}</span>
                          <span className="font-semibold text-xs truncate flex-1 text-center font-sans">{asg.client}</span>
                          <span className="text-[9px] font-bold uppercase px-1.5 py-0.5 rounded bg-black/40 shrink-0">{asg.type}</span>
                        </div>
                        {/* Ligne 2 : [📍 Ville] [Heures] */}
                        <div className="flex items-center justify-between gap-1.5 text-[10px] opacity-95 font-sans leading-tight">
                          <span className="truncate flex-1 flex items-center gap-0.5"><span>📍</span><span className="truncate">{asg.city}</span></span>
                          <span className="font-mono shrink-0 font-semibold">{asg.time}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverPlanningMockup;
